module.exports = __webpack_public_path__ + "img/组合632.5054277e.png";